// ImageContent.jsx
import React from 'react';
import * as S from "../styles";

const ImageContent = ({isImageFirst, images, blockNum, isVisible, className}) => (
    <S.AnimatedBlockPic
        className={isVisible ? 'visible' : ''}
        data-direction={isImageFirst ? 'left' : 'right'}
    >
        <div className={className}>
            {images.map((imageData, idx) => {
                // Проверяем, это объект с Component или просто компонент
                const SvgComponent = imageData.Component || imageData;
                const dimensions = imageData.width ? {
                    width: imageData.width,
                    height: imageData.height
                } : {};

                return (
                    <div
                        key={idx}
                        style={{
                            width: '100%',
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            overflow: 'hidden',
                            transitionDelay: isVisible ? `${idx * 150}ms` : '0ms'
                        }}
                    >
                        <SvgComponent
                            aria-label={`Block ${blockNum} illustration ${idx + 1}`}
                            style={{
                                width: dimensions.width || 'auto',
                                height: dimensions.height || 'auto',
                                maxWidth: '100%',
                                maxHeight: '100%'
                            }}
                        />
                    </div>
                );
            })}
        </div>
    </S.AnimatedBlockPic>
);

export default ImageContent;